import cloneDeep from 'lodash.clonedeep';
import { TargetModel } from 'data/target/target.types';

// eslint-disable-next-line import/prefer-default-export
export const adaptTargetsTypes = (targets: TargetModel[]): TargetModel[] => {
  const clonedTargets = cloneDeep(targets);
  const targetsTypes = new Set();

  clonedTargets.forEach((target) => {
    if (targetsTypes.has(target.primaryType) && target.primaryType === 'SIP-URI') {
      target.primaryType = 'SIP-URI-CUSTOM';
    }
    targetsTypes.add(target.primaryType);
  });

  return clonedTargets;
};
